import * as buttonConst from '@/components/ui/button/Button/const'

export const variants = buttonConst.variants

export const sizes = buttonConst.sizes

export const round = buttonConst.round
